import React, { useState, useEffect } from 'react'
import {
  Box,
  Container,
  VStack,
  HStack,
  Heading,
  Text,
  FormControl,
  FormLabel,
  Input,
  Button,
  Alert,
  AlertIcon,
  useColorModeValue,
  Image,
  Divider,
} from '@chakra-ui/react'
import { useAuth } from '../contexts/AuthContext'
import { useLocation } from 'react-router-dom'

const LoginPage: React.FC = () => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [sessionExpiredMessage, setSessionExpiredMessage] = useState('')
  const { login, isLoading } = useAuth()
  const location = useLocation()

  const bgColor = useColorModeValue('white', 'gray.800')
  const borderColor = useColorModeValue('gray.200', 'gray.600')

  // 🆕 세션 만료 메시지 처리
  useEffect(() => {
    const state = location.state as { message?: string; from?: string }
    if (state?.message) {
      setSessionExpiredMessage(state.message)
      // 3초 후 메시지 자동 제거
      const timer = setTimeout(() => {
        setSessionExpiredMessage('')
      }, 5000)
      return () => clearTimeout(timer)
    }
  }, [location])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setSessionExpiredMessage('')

    if (!username || !password) {
      setError('아이디와 비밀번호를 입력해주세요.')
      return
    }

    const success = await login(username, password)
    if (!success) {
      setError('아이디 또는 비밀번호가 올바르지 않습니다.')
    }
  }

  return (
    <Box minH="100vh" bg="gray.50" display="flex" alignItems="center" justifyContent="center">
      <Container maxW="md" py={12}>
        <Box
          bg={bgColor}
          p={8}
          borderRadius="lg"
          boxShadow="lg"
          border="1px"
          borderColor={borderColor}
        >
          <VStack spacing={6} align="stretch">
            {/* BEXCO 로고 및 제목 */}
            <VStack spacing={4}>
              <Box
                w="80px"
                h="80px"
                bg="bexco.500"
                borderRadius="full"
                display="flex"
                alignItems="center"
                justifyContent="center"
                color="white"
                fontSize="2xl"
                fontWeight="bold"
              >
                BEXCO
              </Box>
              <VStack spacing={2}>
                <Heading size="lg" color="bexco.700">
                  관리자 대시보드
                </Heading>
                <Text color="gray.600" textAlign="center">
                  BEXCO AI 챗봇 관리 시스템
                </Text>
              </VStack>
            </VStack>

            <Divider />

            {/* 로그인 폼 */}
            <form onSubmit={handleSubmit}>
              <VStack spacing={4}>
                {/* 🆕 세션 만료 메시지 */}
                {sessionExpiredMessage && (
                  <Alert status="warning" borderRadius="md">
                    <AlertIcon />
                    {sessionExpiredMessage}
                  </Alert>
                )}
                
                {error && (
                  <Alert status="error" borderRadius="md">
                    <AlertIcon />
                    {error}
                  </Alert>
                )}

                <FormControl isRequired>
                  <FormLabel>아이디</FormLabel>
                  <Input
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="관리자 아이디를 입력하세요"
                    variant="filled"
                  />
                </FormControl>

                <FormControl isRequired>
                  <FormLabel>비밀번호</FormLabel>
                  <Input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="비밀번호를 입력하세요"
                    variant="filled"
                  />
                </FormControl>

                <Button
                  type="submit"
                  colorScheme="bexco"
                  size="lg"
                  width="full"
                  isLoading={isLoading}
                  loadingText="로그인 중..."
                >
                  로그인
                </Button>
              </VStack>
            </form>

            {/* 시스템 정보 */}
            <VStack spacing={2} pt={4}>
              <Text fontSize="sm" color="gray.500" textAlign="center">
                BEXCO 지능형 공간 안내 시스템
              </Text>
              <HStack spacing={4} fontSize="xs" color="gray.400">
                <Text>DMStudio</Text>
                <Text>•</Text>
                <Text>연락처 : 1577-7638</Text>
              </HStack>
            </VStack>
          </VStack>
        </Box>
      </Container>
    </Box>
  )
}

export default LoginPage






